export default __webpack_public_path__ + "images/Moha-Leap-Ceiling.webp";